import React, { useEffect } from 'react';
import { Alert, Form as AntForm, Input } from 'antd';
import Form from '../../../../antd/form/Form/Form.jsx';
import FormTextField from '../../../../antd/form/FormTextField/FormTextField.jsx';
import FormTextArea from '../../../../antd/form/FormTextArea/FormTextArea.jsx';
import FormButton from '../../../../antd/form/FormButton/FormButton.jsx';
import FormButtonsContainer from '../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import FormSwitch from '../../../../antd/form/FormSwitch/FormSwitch.jsx';
import { required, url } from '../../../../antd/form/FormValidation.js';
import { useTranslation } from 'react-i18next';

const PersonForm = ({
  isStudent,
  onSubmit,
  initials,
  form,
  userId,
  userRolesLabel,
}) => {
  const { t } = useTranslation();
  const isTeacher = !isStudent;

  const isEmailSynced = AntForm.useWatch('ldap_mail', form);
  //Reset form values when user leaves impersonation
  useEffect(() => {
    form.setFieldsValue(initials);
  }, [form, initials, userId]);

  return (
    <Form onFinish={onSubmit} initialValues={initials} form={form}>
      <FormTextField
        label={<label className="note-to-field"> {t('Meno')}</label>}
        name="name"
        disabled
      />

      {isStudent && (
        <>
          <FormTextField
            label={
              <label className="note-to-field"> {t('Študijná skupina')}</label>
            }
            name={'school_group'}
            disabled
          />

          <Alert
            title={`\u00A0${t('Tieto údaje sa nachádzajú na školskom LDAP serveri. Ak ich potrebujete zmeniť, kontaktujte správcu LDAP servera Tomáša Majera.')}`}
            type="warning"
            style={{ marginBottom: '24px' }}
            className="note-to-field"
          />
        </>
      )}

      {isTeacher && (
        <>
          <FormTextField
            label={<label className="note-to-field"> {t('Telefón')}</label>}
            name="phone"
            disabled
          />

          <FormTextField
            label={<label className="note-to-field"> {t('Miestnosť')}</label>}
            name="room"
            disabled
          />

          <Alert
            title={`\u00A0${t('Tieto údaje sa nachádzajú na školskom LDAP serveri. Ak ich potrebujete zmeniť, kontaktujte správcu LDAP servera Tomáša Majera.')}`}
            type="warning"
            style={{ marginBottom: '24px' }}
            className="note-to-field"
          />

          <FormTextArea
            label={t('Odborný profil (slovensky)')}
            name="description_sk"
          />

          <FormTextArea
            label={t('Odborný profil (anglicky)')}
            name="description_en"
          />

          <FormTextField
            label={t('URL adresa osobného webu')}
            name="homepage"
            rules={[url(t)]}
          />
        </>
      )}

      <FormTextField
        label={t('Kontaktný email')}
        name="mail"
        rules={!isEmailSynced ? [required(t)] : []}
        disabled={isEmailSynced}
      />

      <AntForm.Item label={t('Roly používateľa')}>
        <Input.TextArea
          value={userRolesLabel}
          disabled
          readOnly
          autoSize={{ minRows: 1, maxRows: 6 }}
          style={{ resize: 'none' }}
        />
      </AntForm.Item>

      <FormSwitch
        label={t(
          'Synchronizovať e-mailovú adresu s nastavením na LDAP serveri',
        )}
        name="ldap_mail"
      />

      <FormSwitch
        label={t('Zasielať aktuality na moju e-mailovú adresu')}
        name="newsletters"
      />

      <FormButtonsContainer>
        <FormButton submitOnClick={true} submitKey={'profile'}>
          {t('Uložiť')}
        </FormButton>
      </FormButtonsContainer>
    </Form>
  );
};

export default PersonForm;
